/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Referral_Apply_FailedInputs */

const en_mobile_referral_apply_failed = /** @type {(inputs: Mobile_Referral_Apply_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn’t apply referral code`)
};

const es_mobile_referral_apply_failed = /** @type {(inputs: Mobile_Referral_Apply_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo aplicar el código de referido`)
};

/**
* | output |
* | --- |
* | "Couldn’t apply referral code" |
*
* @param {Mobile_Referral_Apply_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_referral_apply_failed = /** @type {((inputs?: Mobile_Referral_Apply_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Referral_Apply_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_referral_apply_failed(inputs)
	return en_mobile_referral_apply_failed(inputs)
});